module.exports = __webpack_public_path__ + "9bf3916588af86636cd9ca30d6cb3c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/morocco.jpg
// module id = 602
// module chunks = 0